import $ from 'jquery';
import axios from "axios";
import {getLinks} from "JQueryScripts/sharing/insert-sharing-buttons";

export const clickTestButton = () => {
    $(document).on("click", ".test-page-button", function (e) {
        const classContent = $(this).attr('data-class-content');

        if ($(this).data('id') === 'results-test') {
            showQuizResult();
        }

        if ($(this).data('id') === 'q1-page') {
            $('.material-content-hashtag-list').hide();
            $('.material-content-header').hide();
        }

        $('.' + classContent).addClass(classContent + '--hidden');
        $('#' + $(this).attr('data-id')).removeClass(classContent + '--hidden');
    });

    $(document).on("click", ".test-play-again-button", function () {
        window.location.reload();
    });
};

const showQuizResult = () => {
    const quizHtmlData = $('.material-content-quiz').data();
    const quizData = {'questionAnswers': {}};

    if($('.material-content-header.fixable-div--in-header.fixable-div--fixed-on-mobile .material-content-header-sharing__buttons.share-btn-container').length > 0){
        getLinks($('.material-content-header.fixable-div--in-header.fixable-div--fixed-on-mobile .material-content-header-sharing__buttons.share-btn-container'));
    }

    quizData['quizId'] = quizHtmlData['id'];

    $('.material-content-hashtag-list').show();
    $('.material-content-header:not(.fixable-div--in-header)').show();
    $('.material-content-header.fixable-div--in-header').css('display', '');

    $('.content-test-question').each(function () {
        quizData['questionAnswers'][$(this).data('id')] = $(this).find('.test-answer--wrong').data('id') !== undefined ?
            $(this).find('.test-answer--wrong').data('id') :
            $(this).find('.test-answer--correct').data('id');
    });

    const resultBlock = $('#results-test');

    axios.post(quizHtmlData['url'], quizData)
        .then((response) => {
            if (!response && !response.data) {
                return;
            }

            resultBlock.find('.test-result__count span').text(response.data.countAnswers);
            resultBlock.find('.test-banner__inner').css({'background-image': 'url(' + response.data.imageUrl + ')'});
            resultBlock.find('.test-result__title').text(response.data.title);
            resultBlock.find('.test-result__text').text(response.data.text);

            const element = $("#results-test .quiz-share-btn-container");
            element.data({'entityId': response.data.id, 'additionalId': response.data.countAnswers});

            getLinks(element).then((data) => {
                element.find('.sharing-btn--vk').addClass('sharing-btn--vk-result');
                element.find('.sharing-btn--fb').addClass('sharing-btn--fb-result');
                element.find('.sharing-btn--tg').addClass('sharing-btn--tg-result');
                element.find('.sharing-btn--twitter').addClass('sharing-btn--twitter-result');
            });
        });
};
